import { useTenantLocalStorage } from '@hooks/useLocalStorage';
import { LayoutMode } from '@features/chat/chatTypes';

const LAST_CHAT_KEY = 'last-chat-id';
const CHAT_LAYOUT_MODE_KEY = 'chat-layout-mode';

export function useLastChatId() {
    return useTenantLocalStorage<number | null>(LAST_CHAT_KEY, null);
}

export function useChatLayoutMode() {
    return useTenantLocalStorage<LayoutMode>(CHAT_LAYOUT_MODE_KEY, 'modal');
}
